import * as React from "react";
import { ClickAreaTrigger } from "../../helpers/click-area/click-area-trigger.mjs";
import { Heading } from "../../typography/heading/heading.mjs";
import { AccordionContext } from "../accordion/accordion.mjs";
import { AccordionItemContext } from "../accordion-item/accordion-item-context.mjs";
const AccordionTitle = (props) => {
  const { noContent, id, isOpen, onClick } = React.useContext(AccordionItemContext);
  const { headingLevel } = React.useContext(AccordionContext);
  const { children, className } = props;
  const headingBEM = () => {
    const classArray = ["accordion__heading"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const handleClick = React.useCallback(
    (event) => {
      event.stopPropagation();
      onClick(event);
    },
    [onClick]
  );
  if (noContent) {
    return /* @__PURE__ */ React.createElement(Heading, { className: headingBEM(), level: headingLevel }, /* @__PURE__ */ React.createElement("span", { className: "accordion__title" }, children));
  }
  return /* @__PURE__ */ React.createElement(Heading, { className: headingBEM(), level: headingLevel }, /* @__PURE__ */ React.createElement(ClickAreaTrigger, null, /* @__PURE__ */ React.createElement("button", { type: "button", className: "accordion__title", id: "".concat(id, "-title"), "aria-expanded": isOpen, "aria-controls": id, onClick: handleClick }, children)));
};
export {
  AccordionTitle
};
